import React from 'react'
import dayjs from 'dayjs'
import Link from 'next/link'
import { sendTeaCommEvent } from 'lib/tea-analyze'

export interface IOriginalColumnData {
  program_id: number
  program_name: string
  sort: number
  logo_url: string
  episode: number
  update_time: number
}

interface IProps {
  data: IOriginalColumnData[]
}

function originalColumn({ data = [] }: IProps) {
  return (
    <div className="wrapper" id="original_column">
      <div className="original-column-wrapper">
        <div className="header">
          <div className="logo" />
          <Link href="/video/groups-origin" as={'/video/groups-origin'}>
            <a target="_blank">
              <div
                className="more-nav-wrapper"
                onClick={() => {
                  sendTeaCommEvent('click_orgin_channel_program_more')
                }}
              >
                更多节目 <span className="icon-arrow-right-white" />
              </div>
            </a>
          </Link>
        </div>

        <div className="column-wrapper">
          {data.map((item, index) => {
            return (
              <Link
                key={`column-${index}`}
                href={`/video/groups/${item.program_id}`}
                as={`/video/groups/${item.program_id}`}
              >
                <a
                  className="column-item-a"
                  target="_blank"
                  onClick={() => {
                    sendTeaCommEvent('click_orgin_channel_program_item', {
                      program_name: item.program_name,
                      program_id: item.program_id,
                      rank: index,
                    })
                  }}
                >
                  <div className="column-item">
                    <div
                      className="cover"
                      style={{ backgroundImage: `url(${item.logo_url})` }}
                    />

                    <div className="bottom-wrapper">
                      <div className="program-name">{item.program_name}</div>
                      <div className="bottom-info">
                        <p>
                          {dayjs(item.update_time * 1000).format('MM-DD HH:mm')}
                          更新
                        </p>
                        <p className="tag">
                          共{item.episode}期
                          <span className="icon-arrow-right-yellow" />
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
              </Link>
            )
          })}
        </div>
      </div>
      <style jsx>
        {`
          .wrapper {
            padding-top: 40px;
          }
          .original-column-wrapper {
            height: 345px;
            background: url(${require('static/original-column-bg@3x.png')})
              no-repeat center / cover;
            padding: 24px 18px;
          }

          .original-column-wrapper .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .header .logo {
            width: 134px;
            height: 34px;
            background: url(${require('static/original-logo@3x.png')}) no-repeat
              center / cover;
          }

          .header .more-nav-wrapper {
            display: flex;
            align-items: center;
          }

          .more-nav-wrapper {
            font-size: 16px;
            color: #ffffff;
          }

          .more-nav-wrapper span {
            display: inline-block;
            width: 12px;
            height: 12px;
            background: url(${require('static/ic-arrow-right-white@3x.png')})
              no-repeat center / cover;
            margin-left: 4px;
          }

          .original-column-wrapper .column-wrapper {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 16px;
          }

          .column-wrapper .column-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 180px;
            height: 248px;
            background: #ffffff;
          }

          .column-item-a:hover {
            text-decoration: none;
            color: inherit;
          }

          .column-item .cover {
            width: 180px;
            height: 180px;
            background-repeat: no-repeat;
            background-size: 100%;
            background-position: center;
            border: 1px solid #ffffff;
            box-sizing: border-box;
            transition: background 0.3s ease-in-out;
          }
          .column-item .cover:hover {
            background-size: 110%;
          }
          .column-item .bottom-wrapper {
            width: 180px;
            padding: 12px;
            display: flex;
            flex-direction: column;
            overflow: hidden;
          }

          .bottom-wrapper .program-name {
            width: 100%;
            height: 20x;
            font-size: 16px;
            font-weight: 500;
            color: #1f2129;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .bottom-wrapper .program-name:hover {
            color: #e65800;
          }

          .bottom-wrapper .bottom-info {
            display: flex;
            align-items: center;
            white-space: nowrap;
            margin-top: 4px;
            font-size: 12px;
          }

          .bottom-info .tag {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 16px;
            padding: 0 4px;
            border-radius: 2px;
            background-color: rgba(255, 205, 50, 0.12);
            font-size: 12px;
            color: #8d620b;
            margin-left: 4px;
          }
          .bottom-info .tag:hover {
            background-color: rgba(255, 205, 50, 0.4);
          }
          .tag .icon-arrow-right-yellow {
            width: 8px;
            height: 16px;
            background: url(${require('static/arrow-ic-r@3x.png')}) no-repeat
              center / cover;
            margin-left: 4px;
          }
        `}
      </style>
    </div>
  )
}

export default originalColumn
